
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.79 9.904c-.057-1.41-1.22-2.55-2.648-2.597a2.735 2.735 0 00-1.774.569l-.364.28-.364-.28a2.73 2.73 0 00-1.774-.569c-1.429.046-2.592 1.187-2.648 2.597a2.702 2.702 0 001.095 2.277l.237.176v1.596c0 .438.084.856.237 1.241.61-.201 1.7-.465 3.217-.465 1.517 0 2.607.264 3.217.465.153-.385.237-.804.237-1.241v-1.596l.237-.176a2.702 2.702 0 001.095-2.277zM5.29 9.428h1.334V10.6H5.291V9.428zm2.046 3.808H6.003v-1.172h1.334v1.172zm2.668 0H8.671v-1.172h1.334v1.172zm.712-2.636H9.383V9.428h1.334V10.6zM8 15.899c-1.158 0-2.028.171-2.574.325A3.465 3.465 0 008 17.363c1.021 0 1.94-.44 2.573-1.14C10.028 16.07 9.159 15.9 8 15.9z","fill":"#F8BF1E"}}),_c('path',{attrs:{"d":"M15.966 11.892l-.488-5.163a7.37 7.37 0 00-2.42-4.795A7.548 7.548 0 008 0a7.548 7.548 0 00-5.058 1.934A7.37 7.37 0 00.522 6.73l-.489 5.163a7.275 7.275 0 00.373 3.102 7.37 7.37 0 001.553 2.584A7.532 7.532 0 007.511 20h.977a7.532 7.532 0 005.553-2.422 7.37 7.37 0 001.553-2.584c.348-.996.473-2.04.373-3.102zm-3.325 1.036v1.025c0 2.527-2.082 4.583-4.641 4.583s-4.64-2.056-4.64-4.583v-1.025a3.864 3.864 0 01-1.332-3.07c.081-2.02 1.748-3.655 3.795-3.722A3.98 3.98 0 018 6.703a3.982 3.982 0 012.177-.567c2.047.067 3.714 1.701 3.795 3.722a3.865 3.865 0 01-1.332 3.07z","fill":"#F8BF1E"}})])
          )
        }
      }
    